export function cleanupBootstrapModalBody() {
    if ($('.modal.show').length > 0) {
        return;
    }
    $('body').removeClass('modal-open').css({ paddingRight: '', overflow: '' });
    $('.modal-backdrop').remove();
}

export function bindStackedBootstrapModal($modal, stackedClass) {
    if (!$modal || !$modal.length) {
        return;
    }
    const ns = '.stackBootstrapModal';
    $modal.off(ns);
    $modal.on('show.bs.modal' + ns, function () {
        if (document.querySelectorAll('.modal.show').length > 0) {
            this.classList.add(stackedClass);
        }
    });
    $modal.on('shown.bs.modal' + ns, function () {
        if (!this.classList.contains(stackedClass)) {
            return;
        }
        const zIndex = parseInt(window.getComputedStyle(this).zIndex, 10) || 1060;
        this.style.zIndex = String(zIndex);
        const backdrops = document.querySelectorAll('.modal-backdrop');
        const lastBackdrop = backdrops[backdrops.length - 1];
        if (lastBackdrop) {
            lastBackdrop.style.zIndex = String(zIndex - 1);
        }
    });
    $modal.on('hidden.bs.modal' + ns, function () {
        this.classList.remove(stackedClass);
        this.style.zIndex = '';
        const openModals = document.querySelectorAll('.modal.show').length;
        if (openModals === 0) {
            cleanupBootstrapModalBody();
            return;
        }
        const backdrops = document.querySelectorAll('.modal-backdrop');
        if (backdrops.length > 1) {
            for (let i = 0; i < backdrops.length - 1; i++) {
                backdrops[i].remove();
            }
        }
        if (document.querySelectorAll('.modal-backdrop').length === 0) {
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            document.body.appendChild(backdrop);
        }
        document.body.classList.add('modal-open');
    });
}

export function forceCleanupBootstrapModals() {
    $('.modal.show').each(function () {
        $(this).modal('hide');
    });
    $('body').removeClass('modal-open').css({ paddingRight: '', overflow: '' });
    $('.modal-backdrop').remove();
}

export function hideBootstrapModal($modal) {
    if ($modal && $modal.length) {
        $modal.modal('hide');
    } else {
        cleanupBootstrapModalBody();
    }
}

export function initBootstrapModalBodyCleanup() {
    $(document).off('hidden.bs.modal.bootstrapBodyCleanup', '.modal');
    $(document).on('hidden.bs.modal.bootstrapBodyCleanup', '.modal', cleanupBootstrapModalBody);
}
